import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-pitch" data-id="element-168" data-mp="3rjvz5hlqcyja">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" data-id="element-169" data-mp="1bettc3zu76jg">
        <p className="text-lg font-extrabold text-white" data-id="element-170" data-mp="1bh6kn7rhit96">Método Fútbol Digital</p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-body" data-id="element-171" data-mp="1fh6wqlr42sd2">
          El sistema argentino para acompañar, proteger y potenciar la carrera futbolística de tu
          hijo.
        </p>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-body" data-id="element-172" data-mp="nrc8ytiwjaqi">
          <li data-id="element-173" data-mp="rp07e6jszln5">
            <a href="mailto:solucionesoinformacion@gmail.com" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-174" data-mp="roqikmahvkj1">
              📧 solucionesoinformacion@gmail.com
            </a>
          </li>
          <li data-id="element-175" data-mp="40qmd6uez1x2">
            <a href="https://instagram.com/metodofutboldigital" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-176" data-mp="418kya4jts85">
              📱 @metodofutboldigital
            </a>
          </li>
          <li data-id="element-177" data-mp="6l07xgdqfgr6">
            <a href="https://metodofutboldigital.shop" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-178" data-mp="6ml04zckqnlv">
              🌐 metodofutboldigital.shop
            </a>
          </li>
        </ul>
        <p className="mt-8 text-xs text-subtle" data-id="element-179" data-mp="3o206i8qd2b3l">
          Acceso digital inmediato · Material en PDF · Soporte por email
        </p>
        <p className="mt-3 text-xs text-subtle" data-id="element-180" data-mp="3j2nivlro0zzy">
          © 2026 Método para padres de futbolistas™ — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}